function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#symbol_marker",
  height: 64,
  width: 64
});
var _ref3 = /*#__PURE__*/React.createElement("symbol", {
  fill: "currentColor",
  viewBox: "0 0 64 64",
  id: "symbol_marker"
}, /*#__PURE__*/React.createElement("path", {
  d: "M32.001,32.986c-2.964,0-5.365-2.402-5.365-5.365s2.401-5.364,5.365-5.364 c2.962,0,5.364,2.401,5.364,5.364S34.963,32.986,32.001,32.986z M32.001,14.695c-6.592,0-11.935,5.343-11.935,11.934c0,2.072,0.528,4.019,1.457,5.717c0.027,0.129,9.339,16.303,9.339,16.303c0.234,0.406,0.669,0.658,1.138,0.658c0.47-0.002,0.902-0.252,1.139-0.658c0,0,9.31-16.174,9.338-16.303c0.93-1.697,1.457-3.645,1.457-5.717C43.934,20.038,38.592,14.695,32.001,14.695z"
}));
const SvgIconMarker = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-hidden": "true",
    role: "img",
    height: 64,
    width: 64,
    viewBox: "0 0 64 64",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};
const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconMarker, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-marker.4e02e915.svg";
export { ForwardRef as ReactComponent };